import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEmpty, path } from 'ramda'
import ScrollLock from 'react-scrolllock'
import CanvasActions from 'Redux/CanvasRedux'
import CommentActions from 'Redux/CommentRedux'
import styles from './CanvasStyles'

class Canvas extends Component {
  constructor (props) {
    super(props)
    this.canvas = null
    this.points = []
    this.prevPos = { x: 0, y: 0 }
    this.commentTimeIndex = {}
    this.state = {
      isPainting: false
    }
  }

  componentDidMount () {
    // Here we set up the properties of the canvas element.
    this.prepareCanvas(this.props)
    this.props.canvasClearPoints()
  }

  componentDidUpdate (prevProps) {
    if (this.props.width !== prevProps.width ||
        this.props.height !== prevProps.height) {
      this.prepareCanvas(this.props)
    }
    if (this.props.currentComment !== prevProps.currentComment) {
      this.drawComment(this.props.currentComment)
    }
    if (this.props.paused === false && prevProps.paused === true &&
        !isEmpty(this.props.currentComment)) {
      this.props.commentsSetCurrent({})
    }
    if (this.props.isDrawing === false && prevProps.isDrawing === true) {
      this.props.canvasClearPoints()
      this.ctx.clearRect(0, 0, this.props.width, this.props.height)
    }
  }

  drawComment = (comment) => {
    this.ctx.clearRect(0, 0, this.props.width, this.props.height)
    const points = path(['points', 'data'], comment)
    if (points && points.length) {
      points.forEach((point) => {
        this.paint({
          x: point.start.x * this.props.width,
          y: point.start.y * this.props.height
        }, {
          x: point.stop.x * this.props.width,
          y: point.stop.y * this.props.height
        }, point.color)
      })
    }
  }

  prepareCanvas = (props) => {
    this.canvas.width = props.width
    this.canvas.height = props.height
    this.ctx = this.canvas.getContext('2d')
    this.ctx.lineJoin = 'round'
    this.ctx.lineCap = 'round'
    this.ctx.lineWidth = 2
    this.ctx.clearRect(0, 0, this.props.width, this.props.height)
  }

  onMouseDown = ({ nativeEvent }) => {
    if (this.props.isDrawing) {
      this.setState({isPainting: true})
      this.prevPos = { x: nativeEvent.offsetX, y: nativeEvent.offsetY }
    }
  }

  onMouseMove = ({ nativeEvent }) => {
    if (this.state.isPainting) {
      const offSetData = { x: nativeEvent.offsetX, y: nativeEvent.offsetY }
      // Add the unit position to the line array
      this.points = this.points.concat({
        start: {
          x: this.prevPos.x / this.props.width,
          y: this.prevPos.y / this.props.height
        },
        stop: {
          x: offSetData.x / this.props.width,
          y: offSetData.y / this.props.height
        },
        color: this.props.strokeColor
      })
      this.paint(this.prevPos, offSetData, this.props.strokeColor)
    }
  }

  onTouchStart = (e) => {
    const rect = this.canvas.getBoundingClientRect()
    this.onMouseDown({
      nativeEvent: {
        offsetX: e.touches[0].clientX - rect.left,
        offsetY: e.touches[0].clientY - rect.top
      }
    })
  }

  onTouchMove = (e) => {
    const rect = this.canvas.getBoundingClientRect()
    this.onMouseMove({
      nativeEvent: {
        offsetX: e.touches[0].clientX - rect.left,
        offsetY: e.touches[0].clientY - rect.top
      }
    })
  }

  endPaintEvent = () => {
    if (this.state.isPainting) {
      this.setState({isPainting: false})
      this.props.canvasAddPoints(this.points)
      this.points = []
    }
  }

  paint (prevPos, currPos, strokeColor) {
    const { x, y } = currPos

    this.ctx.beginPath()
    this.ctx.strokeStyle = strokeColor
    // Move the the prevPosition of the mouse
    this.ctx.moveTo(prevPos.x, prevPos.y)
    // Draw a line to the current position of the mouse
    this.ctx.lineTo(x, y)
    // Visualize the line using the strokeColor
    this.ctx.stroke()
    this.prevPos = { x, y }
  }

  setCanvasRef = (ref) => {
    this.canvas = ref
  }

  onPlayPause = () => {
    if (!this.props.isDrawing) {
      this.props.onPlayPause()
    }
  }

  render () {
    const style = !this.props.isDrawing ? { cursor: 'pointer' } : {}
    return (
      <div>
        {this.state.isPainting && <ScrollLock />}
        <canvas
          style={style}
          onClick={this.onPlayPause}
          className={styles.component}
          ref={this.setCanvasRef}
          onMouseDown={this.onMouseDown}
          onMouseLeave={this.endPaintEvent}
          onMouseUp={this.endPaintEvent}
          onMouseMove={this.onMouseMove}
          onTouchStart={this.onTouchStart}
          onTouchEnd={this.endPaintEvent}
          onTouchMove={this.onTouchMove}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  isDrawing: state.canvas.isDrawing,
  points: state.canvas.points,
  currentComment: state.comments.currentComment,
  currentVideo: state.videos.currentVideo,
  strokeColor: state.canvas.strokeColor
})

const mapDispatchToProps = (dispatch) => ({
  commentsSetCurrent: (comment) =>
    dispatch(CommentActions.commentsSetCurrent(comment)),
  canvasAddPoints: points => dispatch(CanvasActions.canvasAddPoints(points)),
  canvasClearPoints: () => dispatch(CanvasActions.canvasClearPoints())
})

export default connect(mapStateToProps, mapDispatchToProps)(Canvas)



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/Canvas/Canvas.js